/**
 * TanStack Router: /workforce/departments/$departmentId/edit
 *
 * Edit existing department form
 * Layout: Authenticated (_auth)
 *
 * @see src/app/workforce/departments/[id]/edit.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import EditDepartmentPage from '@/app/workforce/departments/[id]/edit'

/**
 * Route: /workforce/departments/$departmentId/edit
 * Layout: _auth (authenticated)
 * Component: EditDepartmentPage
 */
export const Route = createFileRoute('/_auth/workforce/departments/$departmentId/edit')({
  component: EditDepartmentPage,
})
